import {
  BrainCircuit, Database, Cloud, AppWindow, Cpu, Users, Building2, Layers,
  Target, UserCheck, Shuffle, Zap, Handshake, HeartPulse, Landmark, Factory,
  Cog, Truck, Car, RadioTower, ShoppingBag, Building, ShieldCheck, HardHat,
  Plane, Briefcase, Clock, Repeat, UserPlus, Globe2, ArrowUpRight, ArrowRight,
  Sparkles, Rocket, Search, ClipboardCheck, LineChart, Network,
} from "lucide-react";

const map = {
  BrainCircuit, Database, Cloud, AppWindow, Cpu, Users, Building2, Layers,
  Target, UserCheck, Shuffle, Zap, Handshake, HeartPulse, Landmark, Factory,
  Cog, Truck, Car, RadioTower, ShoppingBag, Building, ShieldCheck, HardHat,
  Plane, Briefcase, Clock, Repeat, UserPlus, Globe2, ArrowUpRight, ArrowRight,
  Sparkles, Rocket, Search, ClipboardCheck, LineChart, Network,
};

export function Icon({ name, ...props }) {
  const Cmp = map[name] || Sparkles;
  return <Cmp {...props} />;
}

export default Icon;
